import React from 'react';
import { Button } from '@mui/material';

const CButton = (props) => {
  const handleClicks = () => {
    props.onClick();
  };

  return (
    <>
      <Button
        disabled={props.disabled ? props.disabled : false}
        variant="outlined"
        style={{
          width: props.Width ? props.Width : 'auto',
          padding: props.Padding ? props.Padding : 'auto',
          backgroundColor: props.backGroundColor ? props.backGroundColor : '',
          color: props.Color ? props.Color : 'black',
        }}
        onClick={handleClicks}
      >
        {props.title}
      </Button>
    </>
  );
};

export default CButton;
